import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { useTranslation } from "react-i18next";
// import FlipBookControlDemoPdf from "./FlipBookControlDemoPdf";
import { Col, Row, Container } from "react-bootstrap";

function FlipBookControlDemo() {
  // Define the ref with a generic type
  const flipBookRef = useRef<any>(null);

  // Function to navigate to a specific page
  const goToPage = (page: number) => {
    flipBookRef.current?.pageFlip().turnToPage(page);
  };
  const { i18n, t } = useTranslation();

  const [currentView, setCurrentView] = useState("");

  const cardsData = [
    {
      id: 1,
      tag: "Policy",
      title: t("hr_policy"),
    },
    {
      id: 2,
      tag: "ConflictofInterest",
      title: t("ConflictofInterest"),
    },
    {
      id: 3,
      tag: "SaudiLaborSystem",
      title: t("SaudiLaborSystem"),
    },
    {
      id: 4,
      tag: "SaudiLaborSystemUpdates",
      title: t("SaudiLaborSystemUpdates"),
    },
    {
      id: 5,
      tag: "Recommendations",
      title: t("Recommendations"),
    },
    {
      id: 6,
      tag: "Decisiontoamend",
      title: t("Decisiontoamend"),
    },
    {
      id: 6,
      tag: "PromotionPolicy",
      title: t("PromotionPolicy"),
    },
  ];

  return (
    <div>
      <Container>
        <Row className="py-2">
          {cardsData.map((card, index) => (
            <Col
              key={index}
              xs={4}
              className="file-name align-items-center file-item m-3"
              onClick={(e) => setCurrentView(card.tag)}
            >
              <i
                className="bi bi-file-earmark-text"
                style={{ marginRight: "10px", color: "#007bff" }}
              ></i>{" "}
              {card.title}
            </Col>
          ))}
        </Row>
      </Container>
      {/* <FlipBookControlDemoPdf /> */}

      {currentView === "Policy" && (
        <HTMLFlipBook
          width={1324}
          height={1700}
          minWidth={0}
          maxWidth={0}
          minHeight={0}
          maxHeight={0}
          size="stretch" // Fixed or stretch
          flippingTime={1000} // Animation duration
          usePortrait={true} // Portrait mode
          startZIndex={0} // Starting z-index
          autoSize={true} // Auto-resize
          drawShadow={false} // Enable shadow
          useMouseEvents={true} // Mouse events
          startPage={0} // Start from the first page
          className="my-flipbook"
          style={{ border: "1px solid #ccc" }}
          clickEventForward={true} // Forward click events to the next page
          swipeDistance={30} // Distance to trigger swipe action
          showPageCorners={true} // Show corner for page flipping
          disableFlipByClick={false} // Allow page flip on click
          mobileScrollSupport={true} // Enable mobile scrolling support
          maxShadowOpacity={1}
          showCover={true}
        >
          {[...Array(145)].map((_, index) => (
            <div key={index + 1} className="page-book">
              <img
                width={"100%"}
                height={"90%"}
                src={`/book/${index + 1}.jpg`}
                alt={`Page ${index + 1}`}
              />
            </div>
          ))}
        </HTMLFlipBook>
      )}

      {/*----ConflictofInterestPolicy-----*/}
      {currentView === "ConflictofInterest" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/ConflictofInterestPolicy.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}

      {/*----Recommendations-----*/}
      {currentView === "Recommendations" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/Recommendations.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}

      {/*----Decisions-----*/}
      {currentView === "Decisions" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/Decisions.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}

      {/*----Saudi Labor System-----*/}
      {currentView === "SaudiLaborSystem" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/SaudiLaborSystem.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}
      {/*----Saudi Labor System-----*/}
      {currentView === "SaudiLaborSystemUpdates" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/SaudiLaborSystemUpdates.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}

      {currentView === "PromotionPolicy" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/PromotionPolicy.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}

      {currentView === "Decisiontoamend" && (
        <div style={{ height: "80vh" }}>
          <iframe
            src={`/hr/files/Decisiontoamend.pdf#toolbar=0`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      )}
    </div>
  );
}

export default FlipBookControlDemo;
